import { SpatialTreeNode } from "../../tree/tree.spatial.node";
import { RefinementStrategy } from "./tile3d.interfaces";
export class Tile3DNode extends SpatialTreeNode {
    constructor(bounds, depth, error = 0) {
        super(bounds, depth);
        this._refinementStrategy = RefinementStrategy.REPLACEMENT;
        this._geometricError = error;
    }
    get refinementStrategy() {
        return RefinementStrategy.ADDITIVE;
    }
    set refinementStrategy(v) {
        if (v !== this._refinementStrategy) {
            this._refinementStrategy = v;
        }
    }
    get geometricError() {
        return this._geometricError;
    }
    set geometricError(v) {
        if (v !== this._geometricError) {
            this._geometricError = v;
        }
    }
}
//# sourceMappingURL=tile3d.node.js.map